// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1VKX-","inner":"Footer_inner__3wB40"};